<template>
  <a-modal
    :width="width"
    :visible="true"
    :maskClosable="false"
    :confirmLoading="loading"
    cancelText="取消"
    okText="确定"
    centered
    :wrapClassName="form.model.datatype == 'N' ? 'custom-form-modal1' : 'custom-form-modal'"
    @ok="handleSubmit"
    @cancel="
      () => {
        // resetFields();
        $emit('cancel');
      }
    "
  >
    <from-render
      ref="render"
      :form="form"
      :model="modelRef"
      :options="options"
      :validateInfos="validateInfos"
    />
    <template #title>
      <div ref="modalTitleRef" style="width: 100%; cursor: move">{{ title }}</div>
    </template>
    <template #modalRender="{ originVNode }">
      <div :style="transformStyle">
        <component :is="originVNode" />
      </div>
    </template>
  </a-modal>
</template>

<script lang="ts">
import { useForm } from 'ant-design-vue/es/form';
import { computed, defineComponent, reactive, CSSProperties, ref, watch, watchEffect } from 'vue';
import { useDraggable } from '@vueuse/core';
const permissionActions = ['add', 'delete', 'update', 'query', 'import', 'export'];
export default defineComponent({
  name: 'FormModal',
  props: {
    title: {
      type: String,
      required: true,
    },
    form: {
      type: Object,
      default: () => {},
    },
    options: {
      type: Object,
      default: () => {},
    },
    loading: {
      type: Boolean,
    },
    id: {
      type: [String, Number],
    },
  },
  emits: ['ok', 'cancel'],
  setup(props: any, { emit }: any) {
    const width = computed(() => {
      //?width:form.settings.col.length==0?'400px':'800px'
      if (props.form.settings.col == null || props.form.settings.col.length == 0) {
        return '500px';
      }
      if (props.form.settings.col != null && props.form.settings.col.length == 1) {
        return '500px';
      }
      if (props.form.settings.col != null && props.form.settings.col.length == 2) {
        return '800px';
      }
      if (props.form.settings.col != null && props.form.settings.col.length == 3) {
        return '1200px';
      }
    });
    const modelRef = reactive({ ...props.form.model });
    const modalTitleRef: any = ref(null);
    const { x, y, isDragging } = useDraggable(modalTitleRef);
    if (props.form.rules) {
      for (const key of Object.keys(props.form.rules)) {
        if (!modelRef.hasOwnProperty(key)) {
          modelRef[key] = null;
        }
      }
    }
    const startX = ref<number>(0);
    const startY = ref<number>(0);
    const startedDrag = ref(false);
    const transformX = ref(0);
    const transformY = ref(0);
    const preTransformX = ref(0);
    const preTransformY = ref(0);
    const dragRect = ref({ left: 0, right: 0, top: 0, bottom: 0 });
    watch([x, y], () => {
      if (!startedDrag.value) {
        startX.value = x.value;
        startY.value = y.value;
        const bodyRect = document.body.getBoundingClientRect();
        const titleRect = modalTitleRef.value.getBoundingClientRect();
        dragRect.value.right = bodyRect.width - titleRect.width;
        dragRect.value.bottom = bodyRect.height - titleRect.height;
        preTransformX.value = transformX.value;
        preTransformY.value = transformY.value;
      }
      startedDrag.value = true;
    });
    watch(isDragging, () => {
      if (!isDragging) {
        startedDrag.value = false;
      }
    });
    watchEffect(() => {
      if (startedDrag.value) {
        transformX.value =
          preTransformX.value +
          Math.min(Math.max(dragRect.value.left, x.value), dragRect.value.right) -
          startX.value;
        transformY.value =
          preTransformY.value +
          Math.min(Math.max(dragRect.value.top, y.value), dragRect.value.bottom) -
          startY.value;
      }
    });
    const transformStyle = computed<CSSProperties>(() => {
      return {
        transform: `translate(${transformX.value}px, ${transformY.value}px)`,
      };
    });
    const rulesRef = reactive({ ...props.form.rules });
    // watchEffect(() => {
    //   if (props.form.model) {
    //     console.log('update model', props.form.model);
    //   }
    // });
    const { resetFields, validate, validateInfos } = useForm(modelRef, rulesRef);
    const handleSubmit = (e: Event) => {
      e.preventDefault();
      validate()
        .then(() => {
          emit('ok', { ...modelRef });
        })
        .finally(() => {})
        .catch(err => {
          console.log('error', err);
        });
    };
    return {
      props,
      width,
      modelRef,
      handleSubmit,
      resetFields,
      validateInfos,
      modalTitleRef,
      transformStyle,
      permissionActions,
    };
  },
});
</script>
<style>
.custom-form-modal .ant-modal-body {
  max-height: 600px;
  overflow: auto;
}
/*.ant-form-item {*/
/*  margin-bottom: 6px;*/
/*}*/
.custom-form-modal1 .ant-modal-body {
  max-height: 670px;
  overflow: auto;
}
</style>
